<div
  #trustbox
  class="trustpilot-container"
  [attr.data-locale]="trustpilot().dataLocale"
  [attr.data-businessunit-id]="trustpilot().businessUnitId"
  [attr.data-template-id]="trustpilot().templateId"
>
  <a [href]="trustpilot().url" target="_blank" rel="noopener"> Trustpilot </a>
</div>
